if(!window.theme._registeredSections['hero-slider'] === true){
  theme.HeroSlider = (function() {

    /**
     * Constructor
     */
    function HeroSlider(container) {

      const sectionName = container.dataset.sectionName.replace('-', '_');
      const handleViewPromotionEvent = () => {
        const cards = container.querySelectorAll('.hero-slide');
        if (!cards.length || !window.theme.observeElement) { return; }

        [...cards].forEach((card, index) => {
          window.theme.observeElement(card, () => {
            const blockSettings = JSON.parse(card.dataset.blockSettings || {});
            if (!Object.keys(blockSettings)) { return; }

            const creativeName = blockSettings.campaign_name;
            const ecommerce = {
              creative_name: creativeName,
              creative_slot: sectionName,
              promotion_id: `${creativeName} | ${sectionName}`,
              promotion_name: blockSettings.title,
            };
            const menuNavigationAction = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
            const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
            window.pushEvent({
              event: 'view_promotion',
              menu_navigation_state: menuNavigationState,
              ecommerce,
            }, 'ecommerce');

            localStorage.setItem('ga4-promotionView', JSON.stringify(ecommerce));

            const links = card.querySelectorAll('a[href]');
            if (!links.length) { return; }

            links.forEach((link) => {
              link.addEventListener('click', () => {
                const menuNavigationClick = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
                const menuNavigationClickState = menuNavigationClick.menu_navigation_state || {};
                window.pushEvent({
                  event: 'select_promotion',
                  menu_navigation_state: menuNavigationClickState,
                  ecommerce,
                }, 'ecommerce');

              });
            });
          });
        });
      };
      handleViewPromotionEvent();

      this.settings = container.dataset.sectionSettings || '{}';
      this.$slider = $(container).find('.hero-slider');
      this.totalSlides = container.dataset.totalSlides ? Number(container.dataset.totalSlides) : null;

      if (this.totalSlides && this.totalSlides < 2) {
        return;
      }

      // Parse the settings string passed through from liquid
      var userSettings = JSON.parse(this.settings);

      // Create some defaults
      var defaultSettings = {
        infinite: true,
        autoplaySpeed: userSettings.slide_speed,
        speed: (userSettings.slide_speed / 2),
        responsive: [
          {
            breakpoint: window.theme.settings.grid_medium || 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };

      // Merge the objects - userSettings will have precedence
      var sliderSettings = $.extend(defaultSettings, userSettings);
      // Init slick carousel
      this.$slider.slick(sliderSettings);
    }


    /**
     * Event handler that updates the fade setting based on slidesToShow
     */
    HeroSlider.prototype.slideHandler = function(event) {

      if (event.target.name.indexOf('slidesToShow') === -1) {
        return;
      }

      var fade = window.top.document.querySelector('[id$=fade]');

      if (event.target.value > 1) {
        fade.checked = false;
        fade.disabled = true;
      } else {
        fade.checked = true;
        fade.disabled = false;
      }
    };


    /**
     * Shopify section event handler
     */
    HeroSlider.prototype.onSelect = function() {
      window.top.addEventListener('input', this.slideHandler.bind(this));
      window.top.addEventListener('change', this.slideHandler.bind(this));
    };


    /**
     * Shopify section event handler
     */
    HeroSlider.prototype.onDeselect = function() {
      window.top.removeEventListener('input', this.slideHandler.bind(this));
      window.top.removeEventListener('change', this.slideHandler.bind(this));
    };


    /**
     * Shopify section event handler
     */
    HeroSlider.prototype.onBlockSelect = function(event) {
      // Go to the currently selected block in slick carousel and pause
      var index = parseInt(event.target.dataset.slickIndex, 10);
      this.$slider.slick('slickGoTo', index).slick('slickPause');
    };


    /**
     * Shopify section event handler
     */
    HeroSlider.prototype.onBlockDeselect = function() {
      // Resume carousel
      this.$slider.slick('slickPlay');
    };


    return HeroSlider;
  })();
  window.theme.sections.register('hero-slider', theme.HeroSlider);
  window.theme._registeredSections['hero-slider'] = true;
}
